/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { ReactNode } from "react";

import "./DialogBox.scss";

interface DialogBoxProps {
  content?: ReactNode;
  actions?: ReactNode;
}

export const DialogBox = (props: DialogBoxProps) => {
  const { content, actions } = props;

  return (
    <div className="DialogBox">
      {content && <div className="DialogBox__Content">{content}</div>}
      {actions && <div className="DialogBox__Actions">{actions}</div>}
    </div>
  );
};
